const { ACTUAL_THEMES_ROOT_ID } = require('../constants');

// актуальные темы дергают запрос с фейковым ID
// формирование фейка: ACTUAL_THEMES_ROOT_ID + реальный id темы
function getActualThemeId(themeId) {
    if (!themeId) {
        throw Error('no themeId');
    }

    if (themeId >= ACTUAL_THEMES_ROOT_ID) {
        return themeId - ACTUAL_THEMES_ROOT_ID;
    }

    return themeId;
}

module.exports = {
    getActualThemeId
};
